import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "../../lib/auth";

const CARDS = [
  { key: "new_applications", label: "New applications", tid: "ops-card-new" },
  { key: "in_review", label: "In review", tid: "ops-card-in-review" },
  { key: "needs_information", label: "Needs information", tid: "ops-card-needs-info" },
  { key: "approved", label: "Approved", tid: "ops-card-approved" },
  { key: "active_volunteers", label: "Active volunteers", tid: "ops-card-active-volunteers" },
  { key: "active_organizations", label: "Active organizations", tid: "ops-card-active-orgs" },
];

export default function OpsDashboard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/ops/dashboard").then((r) => setD(r.data)).catch((e) => setErr(formatApiErrorDetail(e?.response?.data?.detail)));
  }, []);
  return (
    <div className="space-y-8" data-testid="ops-dashboard">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-slate-900">Overview</h1>
        <Link to="/ops/onboarding" className="text-sm font-medium text-slate-700 hover:text-slate-900" data-testid="ops-dashboard-open-queue">Open onboarding queue →</Link>
      </div>
      {err && <div className="text-sm text-red-700">{err}</div>}
      <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {CARDS.map((c) => (
          <div key={c.key} data-testid={c.tid} className="p-4 bg-white rounded-xl border">
            <div className="text-xs text-slate-500 mb-1">{c.label}</div>
            <div className="text-2xl font-semibold text-slate-900">{d?.summary?.[c.key] ?? "—"}</div>
          </div>
        ))}
      </section>
      <section>
        <h2 className="text-sm font-medium text-slate-600 mb-3">Recent onboarding activity</h2>
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="text-slate-500 bg-slate-50">
              <tr><th className="text-left px-4 py-2">Applicant</th><th className="text-left px-4 py-2">Type</th><th className="text-left px-4 py-2">Status</th><th className="text-left px-4 py-2">Updated</th></tr>
            </thead>
            <tbody>
              {(d?.recent_activity?.ops_applications || []).slice(0, 8).map((r) => (
                <tr key={r.id} className="border-t" data-testid="ops-dashboard-recent-row">
                  <td className="px-4 py-2 text-slate-900">{r.applicant_name || r.organization_name}</td>
                  <td className="px-4 py-2 capitalize">{r.type}</td>
                  <td className="px-4 py-2">{r.status}</td>
                  <td className="px-4 py-2 text-slate-500">{(r.updated_at || "").slice(0, 16).replace("T", " ")}</td>
                </tr>
              ))}
              {(!d?.recent_activity?.ops_applications || d.recent_activity.ops_applications.length === 0) && (
                <tr><td colSpan={4} className="px-4 py-6 text-center text-slate-500">No onboarding activity yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
      <section>
        <h2 className="text-sm font-medium text-slate-600 mb-3">Recent Buddy applications (federated)</h2>
        <div className="bg-white rounded-xl border overflow-hidden">
          <table className="w-full text-sm">
            <thead className="text-slate-500 bg-slate-50">
              <tr><th className="text-left px-4 py-2">Applicant</th><th className="text-left px-4 py-2">Status</th><th className="text-left px-4 py-2">Updated</th></tr>
            </thead>
            <tbody>
              {(d?.recent_activity?.buddy_applications || []).slice(0, 6).map((r) => (
                <tr key={r.id} className="border-t"><td className="px-4 py-2">{r.user_name}</td><td className="px-4 py-2 capitalize">{r.status}</td><td className="px-4 py-2 text-slate-500">{(r.updated_at || "").slice(0, 16).replace("T", " ")}</td></tr>
              ))}
              {(!d?.recent_activity?.buddy_applications || d.recent_activity.buddy_applications.length === 0) && (
                <tr><td colSpan={3} className="px-4 py-6 text-center text-slate-500">No Buddy applications yet.</td></tr>
              )}
            </tbody>
          </table>
          <div className="px-4 py-3 bg-slate-50 border-t text-xs text-slate-500">Buddy applications remain governed by the existing Buddy admin workflow. <Link to="/portal/admin/buddies" className="text-slate-900 font-medium">Open Buddy admin →</Link></div>
        </div>
      </section>
    </div>
  );
}
